import { render, staticRenderFns } from "./updateEmailModal.vue?vue&type=template&id=48bc3952&scoped=true&"
import script from "./updateEmailModal.vue?vue&type=script&lang=js&"
export * from "./updateEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./updateEmailModal.vue?vue&type=style&index=0&id=48bc3952&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bc3952",
  null
  
)

export default component.exports